import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import jsPDF from "jspdf";
import Swal from 'sweetalert2';
import Select from 'react-select';
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import ImportedURL from '../../common/api';
import { bindActionCreators } from 'redux';
import { AC_LIST_GROUP } from '../../actions/groupAction';
import { Error } from '../../common/swal';
import { AC_LIST_HOTEL } from '../../actions/hotelAction';
import * as html2canvas from 'html2canvas';
import Ticketpdf from './ticketpdf';
import { imageCellRendererList, objectToQueryString, onErrorImage } from '../../common/validate';

class ListTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [
                { headerName: 'Ticket #', field: 'ticketid', width: 200, floatingFilter: true, cellStyle: { 'text-align': 'center' } },
                { headerName: 'Problem', field: 'title', width: 200, floatingFilter: true, cellStyle: { 'text-align': 'center' } },
                {
                    headerName: 'Description', field: 'description', width: 200, floatingFilter: true,
                    valueGetter: function (params) {
                        if (params.data && params.data.description) {
                            return params.data.description
                        } else if (params.data && params.data.description == "") {
                            return "---"
                        }
                    }
                },
                {
                    headerName: 'Room #', field: 'roomno', width: 150, floatingFilter: true, cellStyle: { 'text-align': 'center' },
                    valueGetter: function (params) {
                        if (params.data && params.data.roomno) {
                            return params.data.roomno
                        } else if (params.data && params.data.roomno == "" && params.data.place) {
                            return "Other place"
                        }
                    }
                },
                {
                    headerName: 'Logo', width: 50, field: 'logo', hide: true, sortable: false, filter: false, "resizable": false,
                    cellRenderer: imageCellRendererList,
                },
                { headerName: 'Hotel', field: 'hotel', width: 250, hide: true, },
                { headerName: 'Reporter', field: 'reporter', width: 150, floatingFilter: true },
                {
                    headerName: 'Status', width: 250, field: 'status', cellStyle: { 'text-align': 'center' }, suppressMenu: true,
                    cellRenderer: function (params) {
                        if (params.value == 'open') {
                            return `<span class="tag ticket_open">Open</span>`;
                        } else if (params.value === 'inprogress') {
                            return '<span class="tag ticket_inprogress">Inprogress</span>';
                        } else if (params.value === 'reopened') {
                            return '<span class="tag ticket_reopened">Reopened</span>';
                        } else if (params.value === 'assigned') {
                            return '<span class="tag ticket_assigned">Assigned</span>';
                        } else if (params.value === 'inreview') {
                            return '<span class="tag ticket_inreview">Inreview</span>';
                        } else if (params.value === 'closed') {
                            return '<span class="tag ticket_closed">Closed</span>';
                        } else if (params.value === 'completed') {
                            return '<span class="tag ticket_completed">Completed</span>';
                        } else if (params.value === 'Deleted') {
                            return '<span class="tag ticket_deleted">Deleted</span>';
                        }
                    }
                },
                {
                    headerName: 'Date', field: 'time', width: 150, cellStyle: { 'text-align': 'center' },
                    cellRenderer: function (params) {
                        return params.value ? `<span>` + moment(params.data?.time).format(params.data?.dtFormat) + `</span>` : ''
                    }
                },
                // {
                //     headerName: 'Action', field: 'actions', width: 120, sortable: false, filter: false, cellStyle: { 'text-align': 'center' }, headerClass: 'ag-center-header', suppressMenu: true, sortable: false, filter: false,
                //     cellRenderer: function (params) {
                //         return params.value;
                //     }
                // },
            ],
            defaultColumDef: {
                editable: false,
                sortable: true,
                resizable: true,
                filter: true,
                flex: 1,
                minWidth: 100,
            },
            tickets: [],
            originalData: [],
            userTickets: [],
            openCount: 0,
            assignedCount: 0,
            inprogressCount: 0,
            inreviewCount: 0,
            completedCount: 0,
            reopenedCount: 0,
            reassignedCount: 0,
            isDeletedCount: 0,
            ticketid: '',
            hotel: '',
            category: '',
            username: '',
            fromdate: '',
            todate: '',
            month: '',
            status: '',
            hotelName: '',
            showTicket: true,
            openStatus: false,
            assignedStatus: false,
            inprogressStatus: false,
            inreviewStatus: false,
            completedStatus: false,
            reopenedStatus: false,
            reassignedStatus: false,
            totalStatus: true,
            spinner: "",
            columnreset: true,
            ticketCount: '',
            hotelName: '',
            allOption: true,
            isFilterShow: false,
            fromdateValue: '',
            todateValue: '',
            groupoption: { label: 'All', value: '', name: 'hotel' },
            perPage: 25,
            selectedOption: [{ label: 'All', value: '', name: 'hotel' }]
        }
    }

    getDataSource = (query = {}, statuscheck = false) => {
        let group = query.group && query.group != undefined ? query.group : localStorage.getItem("searchgroup");
        let hotel = query.hotel && query.hotel != undefined ? query.hotel : localStorage.getItem("searchhotel");
        let fromdate = query.fromdate && query.fromdate != undefined ? query.fromdate : localStorage.getItem("searchfromdate");
        let todate = query.todate && query.todate != undefined ? query.todate : localStorage.getItem("searchtodate");
        let status = query.status && query.status != undefined ? query.status : localStorage.getItem("searchstatus");
        if (group) query['group'] = group;
        if (hotel) query['hotel'] = (typeof hotel === 'string') ? JSON.parse(hotel) : hotel;
        if (fromdate) query['fromdate'] = fromdate;
        if (todate) query['todate'] = todate;
        if (status) query['status'] = status;
        return {
            getRows: async (params) => {
                // Grid params for filter and sort
                const account = this.props.AccountState.account;
                const dtFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY') + ' ' + (account.timeformat != '' ? account.timeformat : "hh:mm A")
                const page = Math.floor(params.startRow / this.state.perPage);
                const filter = params.filterModel;
                const sortModel = params.sortModel;
                this.setState({ spinner: true });
                var tzone = 'America/chicago'
                if (account != undefined && account && account.tzone != undefined && account.tzone) {
                    tzone = account.tzone
                }
                axios.post(ImportedURL.API.listTicket, { perPage: this.state.perPage, page: page, filter: filter, sort: sortModel.length ? sortModel[0] : {}, ...query })
                    .then((res) => {
                        if (res.data) {
                            res.data.data.forEach(object => {
                                object.actions = `<div><button type="button" class="btn btn-icon" data-action-type="View" data-toggle="modal" data-target="#exampleModal"><i class="fa fa-eye" style='color: #1DC9B7 !important' data-action-type="View"></i></button></div>`;
                                object.tzone = tzone
                                object.dtFormat = dtFormat
                            });
                            if (res.data) this.setState({
                                tickets: res.data.data,
                                originalData: res.data.data,
                                openCount: res.data.open,
                                assignedCount: res.data.assigned,
                                inprogressCount: res.data.inprogress,
                                inreviewCount: res.data.inreview,
                                completedCount: res.data.completed,
                                reopenedCount: res.data.reopened,
                                reassignedCount: res.data.reassigned,
                                isDeletedCount: res.data.isDeleted,
                                ticketCount: res.data.totalstatus,
                                spinner: false
                            });
                            params.successCallback(res.data.data, res.data.total);
                            const lbLastRowOnPageEl = document.querySelector(`[ref=\'lbLastRowOnPage\']`);
                            if (lbLastRowOnPageEl) {
                                lbLastRowOnPageEl.innerHTML = (res.data && res.data.data) ? res.data.data.length + params.startRow : 0;
                            }
                            this.setState({ spinner: false })
                            this.UpdateColumnDefs();
                        }
                    }).catch(({ response }) => {
                        this.setState({ spinner: false });
                        Error("Couldn't fetch records");
                        params.successCallback([], 0);
                    })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { AccountState } = this.props;
        const role = AccountState.role;
        if (this.gridApi && role && ImportedURL.SUPERADMIN.includes(role) && this.state.columnreset) {
            this.UpdateColumnDefs();
            this.setState({ columnreset: false })
        }
        if (this.gridApi) {
            if (AccountState.previleges && prevState.gridApi !== this.state.gridApi) {
                const dataSource = this.getDataSource();
                this.gridApi.setDatasource(dataSource);
            }
        }
    }

    componentDidMount() {
        this.resetLocalStorage();
        const { AccountState } = this.props;
        const account = AccountState.account;
        this.setState({ hotelName: account.hotelName ? account.hotelName : '' });
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    resetLocalStorage = () => {
        localStorage.removeItem("searchgroup");
        localStorage.removeItem("searchhotel");
        localStorage.removeItem("searchfromdate");
        localStorage.removeItem("searchtodate");
        localStorage.removeItem("searchstatus");
    }

    handleChange = e => {

        var value = []
        let label = ''
        let dataStatus = true
        let dataArr = []
        if (e.length > 0) {
            e.map((item, i) => {
                if (e[e.length - 1].label == "All") {
                    value = []
                }
                if (item.label == "All") {
                    dataStatus = false
                    this.setState({ allOption: false })
                } else {
                    if (item.label != 'All') {
                        dataArr.push(item)
                        value.push(item.value)
                        this.setState({ allOption: true })
                        dataStatus = true
                    }
                    if (e.length == 1 && i == 0) {
                        label = item.label
                    }
                }
                if (value.length == 1) {
                    label = item.label
                } else {
                    label = ''
                }
                if (item.label == "All") {
                    if (this.state.fromdate || this.state.todate || this.state.group) {
                        this.setState({ isFilterShow: true })
                    } else {
                        this.setState({ isFilterShow: false })
                    }
                } else {
                    this.setState({ isFilterShow: true })
                }
            })
        }
        localStorage.setItem('searchhotel', JSON.stringify(value));
        const dataSource = this.getDataSource()
        this.gridApi.setDatasource(dataSource);
        this.setState({
            hotel: value,
            hotelName: label,
            selectedOption: dataStatus ? dataArr : [{ label: 'All', value: '', name: 'hotel' }],
        });
        this.resetstatus()
    }

    setGroup = e => {
        const { name, value, label } = e;
        this.setState({ group: value, hotel: '', hotelName: '', selectedOption: label == "All" ? [{ label: 'All', value: '', name: 'hotel' }] : [], totalStatus: true });
        if (label == "All") {
            if (this.state.fromdate || this.state.todate) {
                this.setState({ isFilterShow: true })
            } else {
                this.setState({ isFilterShow: false })
            }
        } else {
            this.setState({ isFilterShow: true })
        }
        localStorage.setItem('searchgroup', value);
        localStorage.removeItem("searchhotel");
        const dataSource = this.getDataSource()
        this.gridApi.setDatasource(dataSource);
        this.resetstatus()

        this.setState({ [name + 'option']: e })
    }

    setDateReport = (e) => {
        const { AccountState } = this.props;
        const { name, value } = e.target;
        const account = AccountState.account;
        var tzone = 'America/chicago'
        if (account != undefined && account && account.tzone != undefined && account.tzone) {
            tzone = account.tzone
        }
        if (name == 'fromdate') {
            this.setState({ fromdate: value, fromdateValue: value, todate: "", todateValue: '', month: "" })
            this.resetstatus()
            localStorage.setItem('searchfromdate', value ? value + "T00:00:00" : '');
            localStorage.removeItem("searchtodate");
            const dataSource = this.getDataSource()
            this.gridApi.setDatasource(dataSource);
        }
        if (name == 'todate') {
            this.setState({ todate: value, todateValue: value, month: "", })
            localStorage.setItem('searchtodate', value ? value + "T23:59:59" : '');
            this.resetstatus()
            const dataSource = this.getDataSource()
            this.gridApi.setDatasource(dataSource);
        }
        if (!localStorage.getItem("searchgroup") && !localStorage.getItem("searchhotel") && !localStorage.getItem("searchfromdate") && !value) {
            this.setState({ isFilterShow: false });
        } else {
            this.setState({ isFilterShow: true });
        }
    }

    getMonthlyReport = e => {
        const account = this.props.AccountState.account;
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        var dFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY');
        const { value } = e.target;
        this.setState({ isFilterShow: true });
        const newval = value == 0 ? 0 : value == 1 ? 1 : 2;
        let date = new Date();
        let startDate = new Date(date.getFullYear(), date.getMonth() - newval, 1);
        let endDate = new Date(date.getFullYear(), date.getMonth() - newval + 1, 0);
        localStorage.setItem('searchfromdate', startDate ? moment(startDate).format('YYYY-MM-DD') + "T00:00:00" : '');
        localStorage.setItem('searchtodate', endDate ? moment(endDate).format('YYYY-MM-DD') + "T23:59:59" : '');
        this.setState({ fromdate: moment(startDate).format('YYYY-MM-DD'), todate: moment(endDate).format('YYYY-MM-DD'), month: value, fromdateValue: moment(startDate).format("YYYY-MM-DD"), todateValue: moment(endDate).format("YYYY-MM-DD") });
        this.resetstatus()
        const dataSource = this.getDataSource()
        this.gridApi.setDatasource(dataSource);
    }

    getMonths = (mon) => {
        let date = new Date();
        date.setDate(1);
        date.setMonth(date.getMonth() - mon);
        let monthName = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);
        return `${monthName}`;
    }

    changeTicketID = e => {
        const { AccountState } = this.props;
        const languageData = AccountState.account.SelectedlanguageData
        const { name, value } = e.target;
        if (name == 'ticketid') {
            axios.get(ImportedURL.API.listTicket, { params: { ticketid: value, hotel: this.state.hotel, } })
                .then((res) => {
                    this.setState({ tickets: res.data, originalData: res.data });
                }).catch(({ response }) => {
                    if (response.status == 500) {
                        Error(response.status + (languageData && languageData.INTERNAL_SERVER_ERROR ? languageData.INTERNAL_SERVER_ERROR : ' Internal Server Error'))
                    } else if (response.status == 502) {
                        Error(response.status + (languageData && languageData.BAD_GATEWAY ? languageData.BAD_GATEWAY : ' Bad Gateway'))
                    } else {
                        Error(response.statusMessage)
                    }
                })
        } else if (name == 'status') {
            axios.get(ImportedURL.API.listTicket, { params: { ticketid: this.state.ticketid, hotel: this.state.hotel, status: value } })
                .then((res) => {
                    this.setState({ tickets: res.data, originalData: res.data });
                }).catch(({ response }) => {
                    if (response.status == 500) {
                        Error(response.status + (languageData && languageData.INTERNAL_SERVER_ERROR ? languageData.INTERNAL_SERVER_ERROR : ' Internal Server Error'))
                    } else if (response.status == 502) {
                        Error(response.status + (languageData && languageData.BAD_GATEWAY ? languageData.BAD_GATEWAY : ' Bad Gateway'))
                    } else {
                        Error(response.statusMessage)
                    }
                })
        }
        this.setState({
            [name]: value
        });
    }

    onRowClicked = event => {
        this.setState({ modalType: "View", id: event.data.ticketid });
    }


    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        this.setState({ gridApi: params.api })
    };

    refreshGridDataSource = () => {
        this.gridApi.purgeInfiniteCache();
        const newDataSource = this.getDataSource();
        if (this.gridApi) {
            this.gridApi.setDatasource(newDataSource);
        }
        this.UpdateColumnDefs();
    };

    onPerPageChange = e => {
        const { value } = e;
        this.setState({ perPage: value }, () => {
            if (this.gridApi) {
                this.gridApi.paginationSetPageSize(parseInt(value, 10));
                this.gridApi.purgeInfiniteCache();
            }
        });
    };

    UpdateColumnDefs = () => {
        const role = this.props.AccountState.role;
        if (this.gridApi && role && ImportedURL.SUPERADMIN.includes(role)) {
            let updatedColumnDefs = [...this.state.columnDefs];
            updatedColumnDefs = updatedColumnDefs.map((col) => {
                if (col.field === 'hotel' || col.field === 'logo') {
                    return { ...col, hide: false };
                }
                return col;
            });
            this.gridApi.setColumnDefs(updatedColumnDefs);
        }
    }

    exportToCSV = () => {
        const account = this.props.AccountState.account;
        const dtFormat = (account.dateformate !== '' ? account.dateformate : 'MM/DD/YYYY') + ' ' + (account.timeformat !== '' ? account.timeformat : 'hh:mm A');
        var firstRow = this.gridApi.getFirstDisplayedRow();
        var lastRow = this.gridApi.getLastDisplayedRow();
        this.gridApi.exportDataAsCsv({
            columnKeys: ['ticketid', 'title', 'description', 'hotel', 'roomno', 'reporter', 'status', 'time'],
            fileName: "Overall-Maintenance-Reports" + "_" + (this.state.hotelName && this.state.hotelName.replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".csv",
            shouldRowBeSkipped: (params) => {
                return params.node.rowIndex < firstRow || params.node.rowIndex > lastRow;
            },
            processCellCallback: function (params) {
                if (params && params.column && params.column.colId === 'time') {
                    return moment(params.value).format(dtFormat);
                } else {
                    return params.value;
                }
            }
        });
    }

    exportPDF = async () => {
        this.setState({ zipspinner: true })
        const account = this.props.AccountState.account;
        const role = this.props.AccountState.role;
        const title = (this.state.hotelName) ? (this.state.hotelName != "All" ? this.state.hotelName + " - Overall Maintenance Reports" : "Overall Maintenance Reports") : "Overall Maintenance Reports";

        let showhotel = account.ImportedURL.SUPERADMIN.includes(role) && title == 'Overall Maintenance Reports';

        const input = document.getElementById('print_pagepdf');
        input.style.visibility = 'visible';
        input.style.overflow = 'auto';
        input.style.height = 'auto';
        let splitarr = [...this.state.tickets].splice(showhotel ? 5 : 7);

        const doc = new jsPDF('landscape', 'px', 'a4');
        let promises = []
        const input1 = document.getElementById('print_pagepdf1');
        promises.push(html2canvas(input1))
        if (splitarr.length) {
            let len = splitarr.length / (showhotel ? 6 : 8);
            for (let k = 0; k < len; k++) {
                const input2 = document.getElementById('print_pagepdf' + k + 2);
                promises.push(html2canvas(input2))
            }
        }
        let promres = await Promise.all(promises)
        promres.map((canvas, i) => {
            const imgData = canvas.toDataURL('image/png');
            const imgProps = doc.getImageProperties(imgData);
            const pdfWidth = doc.internal.pageSize.getWidth();
            const height = doc.internal.pageSize.getHeight();
            const pdfHeight = ((imgProps.height * pdfWidth) / imgProps.width);
            var position = 0;
            while (pdfHeight >= -position) {
                if (i != 0)
                    doc.addPage();
                doc.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
                position -= height;
                if (pdfHeight >= -position) {
                    doc.addPage();
                }
            }
        })
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            if (this.state.hotelName) {
                doc.setFontSize(11);
                doc.setTextColor(110);
                const hotelNameXPosition = 10;
                const hotelNameYPosition = doc.internal.pageSize.getHeight() - 50;
                doc.text(account.hotelNameExport, hotelNameXPosition, hotelNameYPosition);
                doc.setFontSize(11);
                doc.setTextColor(110);
                const hoteladdressXPosition = 10;
                const hoteladdressYPosition = doc.internal.pageSize.getHeight() - 35;
                doc.text(account.hoteladdressExport, hoteladdressXPosition, hoteladdressYPosition);
            }
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            doc.setTextColor(110);

            doc.setFontSize(11);
            doc.setTextColor(110);

            const disclaimerXPosition = 10;
            const disclaimerYPosition = doc.internal.pageSize.getHeight() - 20;
            doc.text('This is an auto-generated report from MyHotel AI (', disclaimerXPosition, disclaimerYPosition);
            doc.setTextColor(28, 48, 120);
            doc.text('www.myhotelai.com )', disclaimerXPosition + doc.getTextWidth('This is an auto-generated report from MyHotel AI ( '), disclaimerYPosition);
            doc.setTextColor(110);
        }
        doc.save("Overall-Maintenance-Reports" + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".pdf");
        input.style.visibility = 'hidden';
        input.style.overflow = 'hidden';
        input.style.height = 0;
        this.setState({ zipspinner: false })
    }

    saveZip = async (datas) => {
        this.setState({ zipspinner: true })
        const account = this.props.AccountState.account;
        var tzone = 'America/chicago'
        try {
            if (account != undefined && account && account.tzone != undefined && account.tzone) {
                tzone = account.tzone
            }
            var dtFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY') + ' ' + (account.timeformat != '' ? account.timeformat : "hh:mm A")
            const zip = new JSZip();
            var img = new Image();
            img.src = '../../assets/images/logo.png';
            for (let i = 0; i < datas.length; i++) {
                let data = datas[i]
                const folder = zip.folder(data.ticketid); // folder name where all files will be placed in 
                const unit = "pt";
                const size = "A4"; // Use A1, A2, A3 or A4
                const orientation = "landscape"; // portrait or landscape


                const doc = new jsPDF(orientation, unit, size);
                doc.setFontSize(15);
                const title = "Ticket Detail";
                const headers = [['Ticket #', "Hotel", "Title", "Description", "Room #", 'Reporter', 'Status', "Time"]];
                const filedata = [[
                    // i + 1,
                    data.ticketid,
                    data.hotel,
                    data.title,
                    data.description,
                    data.roomno != '' ? data.roomno : 'Other place',
                    data.reporter,
                    data.status,
                    moment(data.time).format(dtFormat),
                ]]

                let content = {
                    startY: 70,
                    head: headers,
                    headStyles: { fillColor: [28, 48, 120] },
                    body: filedata,
                    margin: {
                        left: 10,
                        right: 10
                    }
                };
                doc.addImage(img, 'png', 780, 10, 50, 50);
                doc.text(title, 15, 40);
                doc.autoTable(content);
                folder.file(data.ticketid + '.pdf', doc.output('blob'));

                function getBase64Image(canvas) {
                    var dataURL = canvas.toDataURL("image/png");
                    return dataURL;
                }


                function dataURItoBlob(dataurl) {
                    const parts = dataurl.split(','), mime = parts[0].match(/:(.*?);/)[1];
                    if (parts[0].indexOf('base64') !== -1) {
                        const bstr = atob(parts[1]);
                        let n = bstr.length;
                        const u8arr = new Uint8Array(n);

                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n)
                        }
                        return new Blob([u8arr], { type: mime })
                    } else {
                        const raw = decodeURIComponent(parts[1])
                        return new Blob([raw], { type: mime })
                    }
                }
                function loadImage(url) {
                    return new Promise((resolve, reject) => {
                        try {

                            const img = new Image();

                            img.onload = function () {
                                var canvas = document.createElement("canvas");
                                canvas.width = img.width;
                                canvas.height = img.height;
                                var ctx = canvas.getContext("2d");
                                ctx.drawImage(img, 0, 0);

                                var base64Image = getBase64Image(canvas);
                                const blobData = dataURItoBlob(base64Image);
                                resolve(blobData);
                            };
                            img.onerror = function (error) {
                                reject(error);
                            };
                            img.setAttribute('crossOrigin', 'anonymous');
                            img.setAttribute('Access-Control-Allow-Origin', '*');
                            img.setAttribute('mode', 'no-cors');
                            img.src = ImportedURL.FILEURL + url + "?not-from-cache-please";
                        }
                        catch (err) {
                            reject(err);

                        }
                    });
                }

                if (data.images && data.images.length) {
                    const imagesfolder = folder.folder('images'); // folder name where all files will be placed in 
                    for (let j = 0; j < data.images.length; j++) {
                        let url = data.images[j]
                        const blobData = await loadImage(url);
                        const name = url.substring(url.lastIndexOf("/") + 1);
                        imagesfolder.file(name, blobData);
                    }
                }

                if (data.audios && data.audios.length) {
                    const audiofolder = folder.folder('audios'); // folder name where all files will be placed in 

                    data.audios.forEach((url) => {
                        const blobPromise = fetch(ImportedURL.FILEURL + url).then((r) => {
                            if (r.status === 200) return r.blob();
                            return Promise.reject(new Error(r.statusText));
                        });
                        const name = url.substring(url.lastIndexOf("/") + 1);
                        audiofolder.file(name, blobPromise);
                    });
                }

                if (data.videos && data.videos.length) {
                    const videosfolder = folder.folder('videos'); // folder name where all files will be placed in 

                    data.videos.forEach((url) => {
                        const blobPromise = fetch(ImportedURL.FILEURL + url).then((r) => {
                            if (r.status === 200) return r.blob();
                            return Promise.reject(new Error(r.statusText));
                        });
                        const name = url.substring(url.lastIndexOf("/") + 1);
                        videosfolder.file(name, blobPromise);
                    });
                }

            }

            zip.generateAsync({ type: "blob" }).then((blob) => {
                this.setState({ zipspinner: false })
                saveAs(blob, "tickets.zip");
            })
        }
        catch (err) {
            this.setState({ zipspinner: false })
        }
    };

    total = e => {
        localStorage.removeItem("searchstatus");
        this.setState({ spinner: true, openStatus: false, assignedStatus: false, inprogressStatus: false, inreviewStatus: false, completedStatus: false, reopenedStatus: false, reassignedStatus: false, totalStatus: true, isDeletedStatus: false })
        const dataSource = this.getDataSource()
        this.gridApi.setDatasource(dataSource);
    }
    open = e => {
        localStorage.setItem('searchstatus', 'open');
        this.setState({ spinner: true, openStatus: true, totalStatus: false, assignedStatus: false, status: 'open', inprogressStatus: false, inreviewStatus: false, completedStatus: false, reopenedStatus: false, reassignedStatus: false, isDeletedStatus: false })
        const dataSource = this.getDataSource()
        this.gridApi.setDatasource(dataSource);
    }
    assigned = e => {
        localStorage.setItem('searchstatus', 'assigned');
        this.setState({ spinner: true, assignedStatus: true, totalStatus: false, openStatus: false, status: 'assigned', inprogressStatus: false, inreviewStatus: false, completedStatus: false, reopenedStatus: false, reassignedStatus: false, isDeletedStatus: false })
        const dataSource = this.getDataSource()
        this.gridApi.setDatasource(dataSource);
    }
    inprogress = e => {
        localStorage.setItem('searchstatus', 'inprogress');
        this.setState({ spinner: true, inprogressStatus: true, totalStatus: false, openStatus: false, status: 'inprogress', assignedStatus: false, inreviewStatus: false, completedStatus: false, reopenedStatus: false, reassignedStatus: false, isDeletedStatus: false })
        const dataSource = this.getDataSource()
        this.gridApi.setDatasource(dataSource);
    }
    inreview = e => {
        localStorage.setItem('searchstatus', 'inreview');
        this.setState({ spinner: true, inreviewStatus: true, totalStatus: false, openStatus: false, status: 'inreview', assignedStatus: false, inprogressStatus: false, completedStatus: false, reopenedStatus: false, reassignedStatus: false, isDeletedStatus: false })
        const dataSource = this.getDataSource();
        this.gridApi.setDatasource(dataSource);
    }
    completed = e => {
        localStorage.setItem('searchstatus', 'completed');
        this.setState({ spinner: true, completedStatus: true, totalStatus: false, openStatus: false, status: 'completed', assignedStatus: false, inprogressStatus: false, inreviewStatus: false, reopenedStatus: false, reassignedStatus: false, isDeletedStatus: false })
        const dataSource = this.getDataSource();
        this.gridApi.setDatasource(dataSource);
    }
    reopened = e => {
        localStorage.setItem('searchstatus', 'reopened');
        this.setState({ spinner: true, reopenedStatus: true, totalStatus: false, openStatus: false, status: 'reopened', assignedStatus: false, inprogressStatus: false, inreviewStatus: false, completedStatus: false, reassignedStatus: false, isDeletedStatus: false })
        const dataSource = this.getDataSource();
        this.gridApi.setDatasource(dataSource);
    }
    reassigned = e => {
        localStorage.setItem('searchstatus', 'reassigned');
        this.setState({ spinner: true, reassignedStatus: true, totalStatus: false, openStatus: false, status: 'reassigned', assignedStatus: false, inprogressStatus: false, inreviewStatus: false, completedStatus: false, reopenedStatus: false, isDeletedStatus: false })
        const dataSource = this.getDataSource();
        this.gridApi.setDatasource(dataSource);
    }
    isDeleted = e => {
        localStorage.setItem('searchstatus', 'isDeleted');
        this.setState({ spinner: true, inreviewStatus: false, totalStatus: false, openStatus: false, status: 'isDeleted', isDeletedStatus: true, assignedStatus: false, inprogressStatus: false, completedStatus: false, reopenedStatus: false, reassignedStatus: false })
        const dataSource = this.getDataSource();
        this.gridApi.setDatasource(dataSource);
    }
    resetstatus = () => {
        localStorage.removeItem("searchstatus");
        this.setState({
            inreviewStatus: false, totalStatus: true, openStatus: false, isDeletedStatus: false, assignedStatus: false, inprogressStatus: false, completedStatus: false, reopenedStatus: false, reassignedStatus: false
        });
    }
    filterReset = (e) => {
        this.resetLocalStorage();
        this.setState({
            selectedOption: [{ label: 'All', value: '', name: 'hotel' }],
            searchhotel: '',
            fromdate: '',
            todate: '',
            month: '',
            hotel: '', hotelName: '', status: '',
            groupoption: { label: 'All', value: '', name: 'hotel' },
            fromdateValue: '',
            todateValue: '',
            statusProgress: { label: "All", value: 0 },
            isFilterShow: false,
            status: '', group: ''
        });
        this.resetstatus()
        const dataSource = this.getDataSource({}, true)
        this.gridApi.setDatasource(dataSource);
    }
    handleExportPDF = () => {
        const account = this.props.AccountState.account;
        const dtFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY') + ' ' + (account.timeformat != '' ? account.timeformat : "hh:mm A")

        const selectedProperties = this.state.hotelName ? ['ticketid', 'title', 'description', 'roomno', 'reporter', 'status', 'time'] : ['ticketid', 'hotel', 'title', 'description', 'roomno', 'reporter', 'status', 'time'];

        const selectedTickets = this.state.tickets.map(ticket => {
            const selectedTicket = {};
            selectedProperties.forEach(property => {
                if (ticket.hasOwnProperty(property)) {
                    if (property == 'time') {
                        selectedTicket[property] = moment(ticket[property]).format(dtFormat)
                    } else if (property == "roomno") {
                        selectedTicket[property] = ticket[property] ? ticket[property] : "Other Place"
                    } else if (property == "description") {
                        selectedTicket[property] = ticket[property] ? ticket[property] : "---"
                    } else {
                        selectedTicket[property] = ticket[property];
                    }
                }
            });
            return selectedTicket;
        });
        let data = {
            title: (this.state.hotelName) ? (this.state.hotelName != "All" ? this.state.hotelName + " - Overall Maintenance Reports" : "Overall Maintenance Reports") : "Overall Maintenance Reports",
            head: this.state.hotelName ? ["#", "Ticket #", "Problem", "Description", "Room #", "Reported By", "Status", "Date"] : ["#", "Ticket #", "Hotel", "Problem", "Description", "Room #", "Reported By", "Status", "Date"],
            body: selectedTickets,
            hotelNameExport: this.state.hotelName ? account.hotelNameExport : '',
            hoteladdressExport: this.state.hotelName ? account.hoteladdressExport : '',
            limit: this.state.perPage,
            ticketmanagement: true,
            hotelWidth: true
        }
        this.setState({ spinner: true })
        axios.post(ImportedURL.API.downloadPdf, data, { responseType: 'blob' })
            .then((res) => {
                const blob = new Blob([res.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = "Overall-Maintenance-Reports" + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".pdf"
                link.click();
                link.remove();
                window.URL.revokeObjectURL(link.href);
                this.setState({ spinner: false });
            }).catch(({ err }) => {
                this.setState({ spinner: false })
            })
    }
    render() {
        const { AccountState, LandingState } = this.props;
        const listHotels = LandingState.landingdata && LandingState.landingdata.data && LandingState.landingdata.data.length > 1 ? LandingState.landingdata.data[0] : [];
        const account = AccountState.account;
        var dtFormat = (account.dateformate != '' ? account.dateformate : 'MM/DD/YYYY') + ' ' + (account.timeformat != '' ? account.timeformat : "hh:mm A")

        if (this.state.tickets) {
            this.state.tickets.forEach(object => {
                object.dtFormat = dtFormat;
            });
        }
        if (this.state.modalType === 'View') {
            const myObject = { ticketid: this.state.ticketid, hotel: this.state.hotel, status: this.state.status, group: this.state.group, fromdate: this.state.fromdate ? this.state.fromdate + "T00:00:00" : '', todate: this.state.todate ? this.state.todate + "T23:59:59" : '' };
            const objectString = objectToQueryString(myObject)
            return <Redirect to={'view-ticket/' + this.state.id + objectString} />

        }
        const limitOptions = [
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
        ]
        var hotelOptions = [];

        if (listHotels.length > 0) {
            listHotels.map(item => {
                if (this.state.groupoption && this.state.groupoption.value) {
                    if (this.state.groupoption.value == item.group._id) {
                        hotelOptions.push({ label: `${item.name} ${item.city} ${item.state}`, value: item._id, logo: item.logo, name: 'hotel' });
                    }
                } else {
                    hotelOptions.push({ label: `${item.name} ${item.city} ${item.state}`, value: item._id, logo: item.logo, name: 'hotel' });
                }
            })
        }
        if (hotelOptions.length != this.state.selectedOption.length) {
            hotelOptions.unshift({ label: 'All', value: '', name: 'hotel' })
        }
        if (hotelOptions.length == 1) {
            hotelOptions = []
        }
        const listGroup = LandingState.landingdata && LandingState.landingdata.data && LandingState.landingdata.data.length > 1 ? LandingState.landingdata.data[3] : [];
        const groupOptions = []
        if (listGroup.length > 0) {
            groupOptions.push({ label: 'All', value: '', name: 'group' })
        }
        if (listGroup.length > 0) {
            listGroup && listGroup?.filter(filterItem => filterItem.status === true).map(item => {
                groupOptions.push({ label: item.name, value: item._id, name: 'group' });
            })
        }
        const languageData = AccountState.account.SelectedlanguageData
        const title = (this.state.hotelName) ? (this.state.hotelName != "All" ? this.state.hotelName + " - Overall Maintenance Reports" : "Overall Maintenance Reports") : "Overall Maintenance Reports";
        return (
            <>
                <div>
                    <div>
                        <div className="breadcrump">
                            <p> <Link to="/"><h6>{languageData && languageData.DASHBOARD ? languageData.DASHBOARD : "Dashboard"}</h6></Link>  <span><i className="fa fa-angle-right" aria-hidden="true"></i> </span> <Link to="/tickets"><h6 className="highlights_breadcrump"> {languageData && languageData.TICKETS ? languageData.TICKETS : "Tickets"}{languageData && languageData.LIST ? languageData.LIST : ' List'}</h6></Link></p>
                        </div>
                        <div className="section-body pt-3 list_ticket">
                            <div className="container-fluid">
                                <div className="row clearfix">
                                    <div className="col-6 col-md-6 col-xl-3">
                                        <div className="card" >
                                            <div className="card-body ribbon" style={{ backgroundColor: '#e9c1e4', boxShadow: this.state.totalStatus ? '0 0 5px #0a0a0a' : '' }}>
                                                <div className="ribbon-box orange">{this.state.ticketCount ? this.state.ticketCount : 0}</div>
                                                <a className="my_sort_cut" href="#" onClick={this.total} >
                                                    <span className='dash_img'>
                                                        <img src='../../assets/images/totaltickets.png' />
                                                    </span>
                                                    <span className='dash_text'>Total Tickets</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-6 col-xl-3">
                                        <div className="card">
                                            <div className="card-body ribbon " style={{ backgroundColor: '#a8e1ff', borderRadius: this.state.openStatus ? '10px' : '', boxShadow: this.state.openStatus ? '0 0 5px #0a0a0a' : '' }}>
                                                <div className="ribbon-box orange">{this.state.openCount ? this.state.openCount : 0}</div>
                                                <a className="my_sort_cut text-muted" href="#" onClick={this.open}>
                                                    <span className='dash_img'>
                                                        <img src='../../assets/images/opentickets.png' />
                                                    </span>
                                                    <span style={{ color: '#444444' }} className='dash_text'>Open Tickets</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-6 col-xl-3">
                                        <div className="card">
                                            <div className="card-body ribbon" style={{ backgroundColor: '#28e3ff', borderRadius: this.state.assignedStatus ? '10px' : '', boxShadow: this.state.assignedStatus ? '0 0 5px #0a0a0a' : '' }}>
                                                <div className="ribbon-box orange">{this.state.assignedCount ? this.state.assignedCount : 0}</div>
                                                <a className="my_sort_cut text-muted" href="#" onClick={this.assigned}>
                                                    <span className='dash_img'>
                                                        <img src='../../assets/images/assignedtickets.png' />
                                                    </span>
                                                    <span style={{ color: '#444444' }} className='dash_text'>Assigned Tickets</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-6 col-xl-3">
                                        <div className="card">
                                            <div className="card-body ribbon" style={{ backgroundColor: '#eeeaaf', borderRadius: this.state.inprogressStatus ? '10px' : '', boxShadow: this.state.inprogressStatus ? '0 0 5px #0a0a0a' : '' }}>
                                                <div className="ribbon-box orange">{this.state.inprogressCount ? this.state.inprogressCount : 0}</div>
                                                <a className="my_sort_cut text-muted" href="#" onClick={this.inprogress}>
                                                    <span className='dash_img'>
                                                        <img src='../../assets/images/inprogresstickets.png' />
                                                    </span>
                                                    <span style={{ color: '#444444' }} className='dash_text'>In Progress Tickets</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row clearfix">
                                    <div className="col-6 col-md-6 col-xl-3">
                                        <div className="card">
                                            <div className="card-body ribbon" style={{ backgroundColor: '#f5d7bb', borderRadius: this.state.inreviewStatus ? '10px' : '', boxShadow: this.state.inreviewStatus ? '0 0 5px #0a0a0a' : '' }}>
                                                <div className="ribbon-box orange">{this.state.inreviewCount ? this.state.inreviewCount : 0}</div>
                                                <a className="my_sort_cut text-muted" href="#" onClick={this.inreview}>
                                                    <span className='dash_img'>
                                                        <img src='../../assets/images/inreviewtickets.png' />
                                                    </span>
                                                    <span style={{ color: '#444444' }} className='dash_text'>In Review Tickets</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-6 col-xl-3">
                                        <div className="card">
                                            <div className="card-body ribbon" style={{ backgroundColor: '#c4e4a5', borderRadius: this.state.completedStatus ? '10px' : '', boxShadow: this.state.completedStatus ? '0 0 5px #0a0a0a' : '' }}>
                                                <div className="ribbon-box orange">{this.state.completedCount ? this.state.completedCount : 0}</div>
                                                <a className="my_sort_cut text-muted" href="#" onClick={this.completed}>
                                                    <span className='dash_img'>
                                                        <img src='../../assets/images/completedtickets.png' />
                                                    </span>
                                                    <span style={{ color: '#444444' }} className='dash_text'>Completed Tickets</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-6 col-xl-3">
                                        <div className="card">
                                            <div className="card-body ribbon" style={{ backgroundColor: '#D59191', borderRadius: this.state.isDeletedStatus ? '10px' : '', boxShadow: this.state.isDeletedStatus ? '0 0 5px #0a0a0a' : '' }}>
                                                <div className="ribbon-box orange">{this.state.isDeletedCount ? this.state.isDeletedCount : 0}</div>
                                                <a className="my_sort_cut text-muted" href="#" onClick={this.isDeleted}>
                                                    <span className='dash_img'>
                                                        <img src='../../assets/images/deleteblack.png' />
                                                    </span>
                                                    <span style={{ color: '#444444' }} className='dash_text'>Deleted Tickets</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* {this.state.showTicket ? */}
                        <div className="section-body">
                            <div className="container-fluid">
                                <div className="tab-content">
                                    <div className="tab-pane fade show active" id="Departments-list" role="tabpanel">
                                        <div className="card">
                                            <div className="card-header res_tit_tick" style={{ height: '65px' }}>
                                                <div className='d-flex'>
                                                    <div className='rounded_icon'><i className="fa fa-ticket mr-2 "></i></div>
                                                    <div className='d-flex align-items-center'>
                                                        <h3 className="card-title"> {languageData && languageData.TICKETS ? languageData.TICKETS : "Tickets"}{languageData && languageData.LIST ? languageData.LIST : ' List'}</h3>
                                                    </div>
                                                </div>
                                                <div className="card-options">
                                                    {this.state.isFilterShow &&
                                                        <button className='btn topsocial_rest_btn btn-primarys ' type='button' onClick={this.filterReset} style={{ height: '45px !important', width: '115pxpx !important' }}><i className="fa fa-refresh" aria-hidden="true" style={{ fontSize: '20px !importent', marginRight: '7px' }}></i> Reset</button>
                                                    }
                                                    {this.state.tickets.length > 0 ?
                                                        <>
                                                            <a className="btn btn-primary btn-sm nav-link dropdown-toggle ticket_export" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-download mr-2" aria-hidden="true"></i>Export</a>
                                                            <div className="dropdown-menu">
                                                                <a className="dropdown-item" type='button' onClick={this.exportToCSV}><i className="dropdown-icon fa fa-file-excel-o"></i> Excel</a>
                                                                <a className="dropdown-item" type='button' onClick={this.handleExportPDF}><i className="dropdown-icon fa fa-file-pdf-o"></i> PDF</a>
                                                                {ImportedURL.SUPERADMIN.includes(account.role) && <a className="dropdown-item" type='button' onClick={() => this.saveZip(this.state.tickets)}><i className="dropdown-icon fa fa-file-zip-o"></i> ZIP</a>}
                                                            </div>
                                                        </>
                                                        : []}

                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-xl-3 col-lg-2 col-md-2 col-sm-2 ">
                                                        <label className="form-label">{languageData && languageData.LIMIT ? languageData.LIMIT : "Limit"}</label>
                                                        <div className="form-group">
                                                            <Select
                                                                onChange={this.onPerPageChange}
                                                                options={limitOptions}
                                                                defaultValue={limitOptions[0]}
                                                                className='limit_size'
                                                            />
                                                        </div>
                                                    </div>
                                                    {
                                                        (account.allhotels && account.allhotels?.length > 0) ?
                                                            ''
                                                            :
                                                            <>
                                                                <div className="col-lg-2 col-md-2 col-sm-6 col-xl-3">
                                                                    <label className="form-label">{languageData && languageData.GROUP ? languageData.GROUP : "Group"}</label>
                                                                    <div className="form-group">
                                                                        <Select
                                                                            value={this.state.groupoption ? { label: this.state.groupoption.label } : ''}
                                                                            onChange={this.setGroup}
                                                                            options={groupOptions}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 ">
                                                                    <label className="form-label">{languageData && languageData.SEARCH ? languageData.SEARCH : "Search"} {languageData && languageData.HOTEL ? languageData.HOTEL : "Hotel"}</label>
                                                                    <div className="form-group" style={{ marginBottom: '10px' }}>
                                                                        <Select
                                                                            isMulti={true}
                                                                            value={this.state.selectedOption}
                                                                            onChange={this.handleChange}
                                                                            options={hotelOptions}
                                                                            formatOptionLabel={(e) => (
                                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    {e.label != 'All' && <img className='all_search_image_size contain_image' src={ImportedURL.FILEURL + e.logo} onError={onErrorImage} />}
                                                                                    <div style={e.label != 'All' ? { paddingLeft: '10px' } : {}}><span className='all_search_text_size' >{e.label}</span></div>
                                                                                </div>
                                                                            )}
                                                                            styles={{
                                                                                menuList: (provided, state) => ({
                                                                                    ...provided,
                                                                                    maxHeight: '200px', // Set the maximum height for the dropdown list
                                                                                    overflowY: 'auto', // Enable vertical scroll if needed
                                                                                })
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>

                                                            </>
                                                    }
                                                    <div className="col-xl-3 col-lg-2 col-md-5 col-sm-12 col-12  mb-3">
                                                        <label className='form-label'>From Date</label>
                                                        <div className='site_pass_calander'>
                                                            <input type='date' className="form-control" name="fromdate" value={this.state.fromdateValue} onChange={this.setDateReport} ></input>
                                                            <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                        </div>
                                                    </div>
                                                    <div className=" col-xl-3 col-lg-2 col-md-5 col-sm-12 col-12  mb-3">
                                                        <label className='form-label'>To Date</label>
                                                        <div className='site_pass_calander'>
                                                            <input type='date' className="form-control" name="todate" min={this.state.fromdateValue ? this.state.fromdateValue : ''} onChange={this.setDateReport} value={this.state.todateValue}></input>
                                                            <i className="fa fa-calendar-check-o" style={{ cursor: 'pointer', fontSize: '20px', opacity: '0.7' }}></i>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3">
                                                        <div className="form-group">
                                                            <label className='form-label'>Archived Reports</label>
                                                            <div className="selectgroup w-100">
                                                                <label className="selectgroup-item" style={{ zIndex: 0 }}>
                                                                    <input type="radio" name="month" className="selectgroup-input" value={0} onChange={this.getMonthlyReport} checked={this.state.month === '0'} />
                                                                    <span className="selectgroup-button first_month">{this.getMonths(0)}</span>
                                                                </label>
                                                                <label className="selectgroup-item" style={{ zIndex: 0 }}>
                                                                    <input type="radio" name="month" className="selectgroup-input" value={1} onChange={this.getMonthlyReport} checked={this.state.month === '1'} />
                                                                    <span className="selectgroup-button">{this.getMonths(1)}</span>
                                                                </label>
                                                                <label className="selectgroup-item" style={{ zIndex: 0 }}>
                                                                    <input type="radio" name="month" className="selectgroup-input" value={2} onChange={this.getMonthlyReport} checked={this.state.month === '2'} />
                                                                    <span className="selectgroup-button last_month">{this.getMonths(2)}</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="Over_all_table_style table-responsive">
                                                    <div className="ag-theme-alpine ticket_aggridrow">
                                                        <AgGridReact
                                                            key={this.state.perPage}
                                                            rowHeight={82}
                                                            paginationPageSize={this.state.perPage}
                                                            cacheBlockSize={this.state.perPage}
                                                            pagination={true}
                                                            onRowClicked={this.onRowClicked}
                                                            domLayout={"autoHeight"}
                                                            defaultColDef={this.state.defaultColumDef}
                                                            columnDefs={this.state.columnDefs}
                                                            rowDragManaged={true}
                                                            animateRows={true}
                                                            onGridReady={this.onGridReady}
                                                            overlayNoRowsTemplate={"No rows to display"}
                                                            rowModelType={'infinite'}
                                                        >
                                                        </AgGridReact>
                                                    </div>
                                                    {
                                                        (this.state.tickets && this.state.tickets.length == 0)
                                                        &&
                                                        <span className='ag_grid_no_record_show_span' >No rows to display</span>
                                                    }
                                                    {
                                                        this.state.spinner ?
                                                            <div className='common_loader'>
                                                                <img className='loader_img_style_common' src='../../assets/images/load.png' />
                                                                <Spinner className='spinner_load_common' animation="border" variant="info" >
                                                                </Spinner>
                                                            </div> : ""
                                                    }
                                                    {
                                                        this.state.zipspinner ?
                                                            <div className='common_loader' style={{ position: 'fixed', left: '55%', textAlign: 'center' }}>
                                                                <img className='loader_img_style_common' src='../../assets/images/load.png' />
                                                                <Spinner className='spinner_load_common' animation="border" variant="info" >
                                                                </Spinner>
                                                                <p className='pt-2'>Please wait while we are downloading your file It might take some time</p>
                                                            </div> : ""
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="overlay" style={{ display: this.state.spinner || this.state.zipspinner ? 'block' : 'none' }}></div>
                        </div>
                        {/* :
                            <div className="section-body pt-3">
                                <div className="container-fluid">
                                    <div className="tab-content pt-3">
                                        <div className="tab-pane fade show active" id="Departments-list" role="tabpanel">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h3 className="card-title">Reports</h3>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-lg-2 col-md-4 col-sm-6 col-xl-3">
                                                            <label className="form-label">Hotel</label>
                                                            <div className="form-group" style={{ marginBottom: '10px' }}>
                                                                <Select
                                                                    value={this.state.selectedOption}
                                                                    // className="form-control"
                                                                    onChange={this.handleChange}
                                                                    options={listHotels.map(item => {
                                                                        return { label: item.name, value: item._id, name: 'hotel' }
                                                                    })}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="container-fluid">
                                    <div className="tab-content pt-3">
                                        <div className="tab-pane fade show active" id="Departments-list" role="tabpanel">
                                            <div className="row clearfix">
                                                {this.state.userTickets.map((rows, i) => {
                                                    return <div className="col-lg-3 col-md-6" key={i}>
                                                        <div className="card"><div className="card-body text-center">
                                                            <img className="img-thumbnail rounded-circle avatar-xxl" src={ImportedURL.FILEURL + rows.hotel_logo} alt="" />
                                                            <h6 className="pt-3">{rows.assignee_name}</h6><div className="text-center text-muted mb-3">{rows.assignee_email}</div>
                                                        </div>
                                                            <div className="card-footer text-center">
                                                                <div className="row clearfix">
                                                                    <div className="col-6">
                                                                        <h5 className="mb-0">{rows.totalCount}</h5>
                                                                        <div className="text-muted">Tickets</div>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <h5 className="mb-0">{rows.completedCount}</h5>
                                                                        <div className="text-muted">Completed</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>} */}
                    </div>
                    <Ticketpdf data={this.state.tickets} title={title} dtFormat={dtFormat} role={account.role} />
                </div>

            </>
        )
    }
}
const mapStateToProps = state => ({
    AccountState: state.account,
    LandingState: state.landing,
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ ListGroup: AC_LIST_GROUP, ListHotel: AC_LIST_HOTEL, }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(ListTicket);